import { customInspectionTypeSettings } from '../domain/customInspectionTypes/customInspectionTypeSettings';
import { mergeObjects } from '../utils/mergeObjects';
import en from './en';
import nlOnly from './nl';

const nl = { ...en, ...nlOnly };

const languages = { en, nl } as any;

const customInspectionTypesEn = Object.keys(customInspectionTypeSettings).map(
    (customInspectionType) => customInspectionTypeSettings[customInspectionType]!.translation.en ?? {},
);
const customInspectionTypesNl = Object.keys(customInspectionTypeSettings).map(
    (customInspectionType) => customInspectionTypeSettings[customInspectionType]!.translation.nl ?? {},
);

languages.en = mergeObjects(languages.en, ...customInspectionTypesEn);
languages.nl = mergeObjects(languages.nl, ...customInspectionTypesNl);

export function translateKeyLang(languageCode: string, key: string, ...variables: string[]): string {
    const parts = key.split('.');
    const language = languages[languageCode];

    if (!language) {
        throw new Error(`Invalid languageCode "${languageCode}"`);
    }

    if (parts[0] === undefined) {
        console.error(`Translate: cannot split key "${key}"`);
        return `*** Translate error: cannot split key "${key}" ***`;
    }
    if (parts[1] === undefined) {
        console.error(`Translate: cannot split key "${key}"`);
        return `*** Translate error: cannot split key "${key}" ***`;
    }

    if (!language[parts[0]]) {
        console.error(`Translate: cannot find key "${parts[0]}"`);
        return `*** Translate error: cannot find key "${parts[0]}" ***`;
    }
    if (!language[parts[0]][parts[1]]) {
        console.error(`Translate: cannot find key "${key}"`);
        return `*** Translate error: cannot find key "${key}" ***`;
    }
    let translateResult = language[parts[0]][parts[1]];
    for (let i = 0; i < variables.length; i++) {
        translateResult = translateResult.replace(new RegExp(`\\{${i}\\}`, 'g'), variables[i]);
    }
    return translateResult;
}

export function getTranslate(languageCode: string) {
    return (key: string, ...variables: string[]) => translateKeyLang(languageCode, key, ...variables);
}
